<template>
  <div class="addLinkManagement">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backlink')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" class="form" :label-width="require('@/config/enum').c_ws3"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_linktitle')" prop="newLinkTitle">
          <el-input v-model="form.newLinkTitle" :placeholder="$t('lang.key_linktitle')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_linkcontent')" prop="newLinkContent">
          <quill-editor v-model="form.newLinkContent" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span
            class="editorText">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
        </el-form-item>
        <el-button class="btn-first" @click="chgHtml()">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="saveHtml('form')">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:addLinkManagement
   *@Description:添加链接
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-02-19
   */

  // 引入富文本功能键tooltip效果
  import {
    addQuillTitle
  } from '../../../config/quill-title.js'
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
    ['blockquote', 'code-block'], // 引用，代码块
    [{
      header: 1
    }, {
      header: 2
    }], // 标题，键值对的形式；1、2表示字体大小
    [{
      list: 'ordered'
    }, {
      list: 'bullet'
    }], // 列表
    [{
      script: 'sub'
    }, {
      script: 'super'
    }], // 上下标
    [{
      indent: '-1'
    }, {
      indent: '+1'
    }], // 缩进
    [{
      direction: 'rtl'
    }], // 文本方向
    [{
      size: ['small', false, 'large', 'huge']
    }], // 字体大小
    [{
      header: [1, 2, 3, 4, 5, 6, false]
    }], // 几级标题
    [{
      color: []
    }, {
      background: []
    }], // 字体颜色，字体背景颜色
    [{
      font: []
    }], // 字体
    [{
      align: []
    }], // 对齐方式
    ['clean'], // 清除字体样式
    ['insertMetric'], // 电话号码（点击可拨打）
    ['link', 'image', 'video'] // 上传图片、上传视频
  ]
  export default {
    name: 'App',
    data() {
      return {
        isLength: 0,
        id: '',
        form: {
          newLinkContent: '',
          newLinkTitle: ''
        },
        rules: {
          newLinkTitle: [{
            required: true,
            message: this.$i18n.t('lang.key_linktitle'),
            trigger: 'blur'
          }],
          newLinkContent: [{
            required: true,
            message: this.$i18n.t('lang.key_linkcontent'),
            trigger: 'blur'
          }]
        },
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                insertMetric: this.showHandle
              }
            }
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text'),
        }
      }
    },
    destroyed() {
      window.localStorage.setItem('ljform', JSON.stringify(this.form))
    },
    created() {
      if (window.localStorage.getItem('ljform')) {
        this.form = JSON.parse(window.localStorage.getItem('ljform'))
      } else {
        if (this.$route.query.id) {
          this.id = this.$route.query.id
          this.editLink()
        }
      }
    },
    methods: {
      // 将选中电话号码套上<a href="tel:"></a>标签
      showHandle() {
        let phoneNum = this.getSelectionText()
        let newLinkContent = this.form.newLinkContent
        let index = newLinkContent.indexOf(phoneNum)
        if (index != -1) {
          newLinkContent = newLinkContent.substr(0, index) + '<a href="tel://' + phoneNum + '">' + newLinkContent.substr(index, phoneNum.length) + '</a>' + newLinkContent.substr(index + phoneNum.length)
        }
        this.form.newLinkContent = newLinkContent
        // alert(newLinkContent)
      },
      // 获取富文本选中的文字
      getSelectionText() {
        if (window.getSelection) {
          return window.getSelection().toString()
        } else if (document.selection && document.selection.createRange) {
          return document.selection.createRange().text
        }
        return ''
      },
      // 自定义按钮内容初始化
      initButton() {
        const editorButton = document.querySelector('.ql-insertMetric')
        editorButton.innerHTML = '<i class="el-icon-link" style="font-size: 18px;color:black"></i>'
      },
      editLink() {
        let loading = this.$loading()
        this.$get(`/links/` + this.id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.form.newLinkContent = res.content
              this.form.newLinkTitle = res.title
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.form.newLinkContent == '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
        this.manualValidate()
      },
      // 富文本验证
      manualValidate() {
        this.$refs.form.validateField('content')
      },
      chgHtml() {
        this.form.newLinkContent = ''
        this.form.newLinkTitle = ''
        this.$refs.form.resetFields()
      },
      jump() {
        this.$router.push({
          name: 'linkManagementList'
        })
      },
      saveHtml(formName) {
        let newLinkContent = this.form.newLinkContent.replace(/<img/g, "<img style='max-width:100%;height:auto;display:block;'")
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.id === '') {
              let loading = this.$loading()
              let params = {
                title: this.form.newLinkTitle,
                content: newLinkContent
              }
              this.$post(`/links/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'linkManagementList'
                    })
                  }
                  setTimeout(() => {
                    loading.close()
                  }, 200)
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let params = {
                title: this.form.newLinkTitle,
                content: newLinkContent,
              }
              let loading = this.$loading()
              this.$patch(`/links/${this.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(
                      this.$i18n.t('lang.lab_modify_success')
                    )
                    this.$router.push({
                      name: 'linkManagementList'
                    })
                  }
                  setTimeout(() => {
                    loading.close()
                  }, 200)
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          }
        })
      }
    },
    // 调用富文本方法生效
    mounted() {
      addQuillTitle()
      this.initButton()
    }
  }
</script>

<style lang="scss">
  .addLinkManagement .el-form-item__content {
    width: 60vw !important;
  }
</style>